import { Loader, BaasicTable, TableFilter, BaasicHeader, BaasicTableExport } from 'core/components';
import { PickingBatchListDetail } from 'modules/picking-batch/pages';
import { defaultTemplate } from 'core/hoc';
import { fileNames } from 'common/constants';
import React from 'react';
import ReactTooltip from 'react-tooltip';
import { OrderDateRangeFilter } from 'modules/order/pages';

const PickingBatchListTemplate = ({
	actions,
	viewStore,
	viewStore: { loading, listStore, tableData, queryUtility, isExpand, onExpandChange, change, columnFilterSetup, orderDateRangeViewStore },
}) => {
	if (loading) return <Loader />;
	return (
		<section className="layout__main__body">
			<BaasicHeader title="MAINMENU.PICKINGBATCHES.TITLE">
				{<OrderDateRangeFilter orderDateRangeViewStore={orderDateRangeViewStore} />}
				<BaasicTableExport tableViewStore={viewStore} fileTitle={fileNames.pickingBatch} />
			</BaasicHeader>
			<div className="k-grid--expandable__cell fullheight">
				<BaasicTable
					{...{
						listStore,
						tableData,
						queryUtility,
						viewStore: viewStore,
						actions,
						detailComponent: PickingBatchListDetail,
						isExpand,
						change,
					}}
					data={listStore.data.slice()}
					expandChange={onExpandChange}
				/>
			</div>
			<ReactTooltip />
			<TableFilter viewStore={viewStore} columnFilterSetup={columnFilterSetup} />
		</section>
	);
};
export default defaultTemplate(PickingBatchListTemplate);
